import axios from "axios";

const BASE_URL = process.env.REACT_APP_API_URL;

// Common headers
const getAuthHeaders = () => {
    const token = localStorage.getItem("authToken");

    return {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
        Accept: "*/*",
    };
};

// ================= GET ALL SETTLEMENTS =================
export const getAllSettlementsAPI = async () => {
    try {
        const response = await axios.get(
            `${BASE_URL}/food/api/settlements/get/all`,
            {
                headers: getAuthHeaders(),
            }
        );

        return response.data;
    } catch (error) {
        console.error("Error fetching settlements:", error);
        throw error;
    }
};

// ================= UPDATE SETTLEMENT STATUS =================
export const updateSettlementStatusAPI = async (
    settlementId,
    updateData
) => {
    try {
        const response = await axios.put(
            `${BASE_URL}/food/api/settlements/update/${settlementId}`,
            updateData,
            {
                headers: getAuthHeaders(),
            }
        );

        return response.data;
    } catch (error) {
        console.error("Error updating settlement:", error);
        throw error;
    }
};

export const getAllCouponsAPI = async () => {
    try {
        const response = await axios.get(
            `${BASE_URL}/food/api/vendor/coupon/getAll`,
            {
                headers: getAuthHeaders(),
            }
        );

        return response.data;
    } catch (error) {
        console.error("Error fetching coupons:", error);
        throw error;
    }
};

export const getTopRatedPaidVendorsAPI = async () => {
    try {
        const response = await axios.get(
            `${BASE_URL}/food/api/admin/toprated/paid`,
            {
                headers: getAuthHeaders(),
            }
        );

        return response.data;
    } catch (error) {
        console.error("Error fetching top rated paid vendors:", error);
        throw error;
    }
};